import { create } from 'zustand';

interface GamificationState {
  pendingXP: number;
  leveledUp: boolean;
  newLevel: number | null;
  // Actions
  addXP: (amount: number) => void;
  showLevelUp: (level: number) => void;
  clearXP: () => void;
  clearLevelUp: () => void;
}

export const useGamificationStore = create<GamificationState>((set) => ({
  pendingXP: 0,
  leveledUp: false,
  newLevel: null,

  addXP: (amount) => set((s) => ({ pendingXP: s.pendingXP + amount })),
  showLevelUp: (level) => set({ leveledUp: true, newLevel: level }),
  clearXP: () => set({ pendingXP: 0 }),
  clearLevelUp: () => set({ leveledUp: false, newLevel: null }),
}));
